<template>
  <span class="saspin" role="progressbar" aria-label="Cargando" :style="{ width: dim, height: dim }" />
</template>

<script setup>
import { computed } from 'vue';
// CSS spinner — replaces Vuetify's <v-progress-circular indeterminate>.
const props = defineProps({
  size: { type: [Number, String], default: 32 },
});
const dim = computed(() => (typeof props.size === 'number' ? `${props.size}px` : props.size));
</script>

<style scoped>
.saspin {
  display: inline-block;
  border-radius: 50%;
  border: 3px solid rgba(181, 33, 24, 0.2);
  border-top-color: #b52118;
  animation: saspin 0.7s linear infinite;
}
@keyframes saspin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .saspin { animation-duration: 1.6s; } }
</style>
